// src/data/categories.js
// Определение категорий инструментов

const categories = [
  { 
    id: 'popular', 
    name: 'Популярное', 
    iconName: 'crown', 
    color: 'indigo',
    description: 'Наиболее часто используемые инструменты',
    slug: 'popular',
    metaTitle: 'Популярные инструменты и калькуляторы | Gensio',
    metaDescription: 'Подборка самых популярных инструментов и калькуляторов для ежедневных задач на Gensio',
  },
  { 
    id: 'finance', 
    name: 'Финансы', 
    iconName: 'calculator', 
    color: 'indigo',
    description: 'Финансовые калькуляторы и конвертеры для расчета кредитов, вкладов, валют и других финансовых операций',
    slug: 'finance',
    metaTitle: 'Финансовые калькуляторы и конвертеры | Gensio',
    metaDescription: 'Набор финансовых инструментов для расчета кредитов, ипотеки, вкладов, конвертации валют и других финансовых операций',
  },
  { 
    id: 'health', 
    name: 'Здоровье', 
    iconName: 'heart', 
    color: 'emerald',
    description: 'Калькуляторы для контроля здоровья, питания и физической активности',
    slug: 'health',
    metaTitle: 'Калькуляторы здоровья и питания | Gensio',
    metaDescription: 'Инструменты для расчета показателей здоровья, планирования питания и контроля физической активности',
  },
  { 
    id: 'travel', 
    name: 'Путешествия', 
    iconName: 'globe', 
    color: 'purple',
    description: 'Инструменты для путешественников: конвертеры валют, часовых поясов и температур',
    slug: 'travel',
    metaTitle: 'Инструменты для путешествий | Gensio',
    metaDescription: 'Полезные конвертеры и калькуляторы для путешествий: валюты, часовые пояса, температуры и другие измерения',
  },
  { 
    id: 'home', 
    name: 'Дом и ремонт', 
    iconName: 'home', 
    color: 'fuchsia',
    description: 'Калькуляторы и конвертеры для ремонта и обустройства дома',
    slug: 'home',
    metaTitle: 'Калькуляторы для дома и ремонта | Gensio',
    metaDescription: 'Инструменты для планирования ремонта, расчета материалов, конвертации единиц измерения и других бытовых задач',
  },
  { 
    id: 'time', 
    name: 'Время и даты', 
    iconName: 'calendar', 
    color: 'cyan',
    description: 'Инструменты для работы с датами, временем и планированием',
    slug: 'time',
    metaTitle: 'Калькуляторы времени и дат | Gensio',
    metaDescription: 'Инструменты для расчета дат, промежутков времени, рабочих дней и других операций с календарем',
  },
  { 
    id: 'generators', 
    name: 'Генераторы', 
    iconName: 'key', 
    color: 'violet',
    description: 'Генераторы паролей, случайных чисел и других значений',
    slug: 'generators',
    metaTitle: 'Генераторы паролей и других значений | Gensio',
    metaDescription: 'Надежные генераторы паролей, случайных чисел и других значений для различных задач',
  }
];

export default categories;